import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "table table-striped" }
const _hoisted_2 = {
  key: 0,
  scope: "col"
}
const _hoisted_3 = { scope: "row" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["href"]
const _hoisted_7 = {
  key: 0,
  class: "badge badge-secondary mr-1",
  title: "Global Admin"
}
const _hoisted_8 = {
  key: 1,
  class: "badge badge-secondary mr-1",
  title: "Organization Admin"
}
const _hoisted_9 = {
  key: 2,
  class: "badge badge-secondary mr-1",
  title: "Workspace User"
}
const _hoisted_10 = {
  key: 3,
  class: "badge badge-secondary mr-1",
  title: "Business User"
}
const _hoisted_11 = {
  key: 4,
  class: "badge badge-info",
  title: "Service User"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'UsersTable',
  props: {
    users: {},
    showActive: { type: Boolean, default: true }
  },
  setup(__props: any) {

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("thead", null, [
      _createElementVNode("tr", null, [
        _cache[0] || (_cache[0] = _createElementVNode("th", { scope: "col" }, "#", -1 /* CACHED */)),
        (__props.showActive)
          ? (_openBlock(), _createElementBlock("th", _hoisted_2, "Active"))
          : _createCommentVNode("v-if", true),
        _cache[1] || (_cache[1] = _createElementVNode("th", { scope: "col" }, "Email", -1 /* CACHED */)),
        _cache[2] || (_cache[2] = _createElementVNode("th", { scope: "col" }, "Display name", -1 /* CACHED */)),
        _cache[3] || (_cache[3] = _createElementVNode("th", { scope: "col" }, "First", -1 /* CACHED */)),
        _cache[4] || (_cache[4] = _createElementVNode("th", { scope: "col" }, "Last", -1 /* CACHED */)),
        _cache[5] || (_cache[5] = _createElementVNode("th", { scope: "col" }, "User type", -1 /* CACHED */))
      ])
    ]),
    _createElementVNode("tbody", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.users, (u, i) => {
        return (_openBlock(), _createElementBlock("tr", {
          key: u.UserId
        }, [
          _createElementVNode("th", _hoisted_3, _toDisplayString(i+1), 1 /* TEXT */),
          (__props.showActive)
            ? (_openBlock(), _createElementBlock("td", _hoisted_4, _toDisplayString((!u.IsLocked && !u.Deleted) ? 'Yes' : 'No'), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          _createElementVNode("td", null, [
            (u.OrganizationUnitId)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: `/#/admin/organizations/users/manage/${u.OrganizationUnitId}/${u.UserId}`
                }, _toDisplayString(u.Email), 9 /* TEXT, PROPS */, _hoisted_5))
              : (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  href: `/#/admin/organizations/users/manage/${u.UserId}`
                }, _toDisplayString(u.Email), 9 /* TEXT, PROPS */, _hoisted_6))
          ]),
          _createElementVNode("td", null, _toDisplayString(u.DisplayName), 1 /* TEXT */),
          _createElementVNode("td", null, _toDisplayString(u.FirstName), 1 /* TEXT */),
          _createElementVNode("td", null, _toDisplayString(u.LastName), 1 /* TEXT */),
          _createElementVNode("td", null, [
            (u.IsGlobalAdmin)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, "GA"))
              : _createCommentVNode("v-if", true),
            (u.IsOrganizationAdmin)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, "OA"))
              : _createCommentVNode("v-if", true),
            (u.IsWorkspaceUser)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, "WU"))
              : _createCommentVNode("v-if", true),
            (u.IsBusinessUser)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, "BU"))
              : _createCommentVNode("v-if", true),
            (u.IsServiceUser)
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, "SU"))
              : _createCommentVNode("v-if", true)
          ])
        ]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}
}

})